import React, { useState } from 'react';
import config from '../config';
import './ComparisonWorkspace.css';
import CompanyDisambiguationModal from './CompanyDisambiguationModal';

export default function SearchAndAddModal({ 
    isOpen, 
    onClose, 
    onAddPatent, 
    existingPatentNumbers,
    token 
}) {
    const [searchQuery, setSearchQuery] = useState('');
    const [searchType, setSearchType] = useState('ai');
    const [searching, setSearching] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [showDisambiguation, setShowDisambiguation] = useState(false);
    const [disambiguationMatches, setDisambiguationMatches] = useState([]);

const handleClose = () => {
    setSearchQuery('');
    setSearchResults([]);
    setErrorMessage('');
    onClose();
};

    const handleDisambiguationSelect = (selectedCompany) => {
    setShowDisambiguation(false);
    setDisambiguationMatches([]);
    searchDirect(selectedCompany);
};

const searchDirect = async (exactQuery) => {
    setSearching(true);
    setErrorMessage('');
    setSearchResults([]);

    try {
        const response = await fetch(
            `${config.API_URL}/api/search-db?query=${encodeURIComponent(exactQuery)}&status=both&assignee_only=${searchType === 'assignee'}&inventor_only=${searchType === 'inventor'}&patent_only=${searchType === 'patent'}&token=${token}`
        );

        if (!response.ok) {
            throw new Error('Search failed');
        }

        const data = await response.json();
        setSearchResults(data.results || []);

        if (!data.results || data.results.length === 0) {
            setErrorMessage('No patents found. Try different search terms.');
        }
    } catch (error) {
        console.error('Search error:', error);
        setErrorMessage('Search failed. Please try again.');
    } finally {
        setSearching(false);
    }
};

const handleSearch = async () => {
    if (!searchQuery.trim()) {
        setErrorMessage('Please enter a search term');
        return;
    }

    if (searchType === 'assignee') {
        try {
            const disambigResponse = await fetch(`${config.API_URL}/api/search/disambiguate-assignee?query=${encodeURIComponent(searchQuery)}`);
            const disambigData = await disambigResponse.json();

            if (disambigData.needs_disambiguation && disambigData.matches.length > 1) {
                setDisambiguationMatches(disambigData.matches);
                setShowDisambiguation(true);
                return;
            }

            const exactName = disambigData.matches.length === 1 ? disambigData.matches[0].assignee : searchQuery;
            searchDirect(exactName);
        } catch (err) {
            searchDirect(searchQuery);
        }
    } else {
        searchDirect(searchQuery);
    }
};

const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
        handleSearch();
    }
};

    const handleAddToComparison = (patent) => {
        onAddPatent(patent);
    };

    const isAlreadyAdded = (patentNumber) => {
        return existingPatentNumbers.includes(patentNumber);
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2 className="modal-title">Search & Add Patents to Comparison</h2>
                    <button className="modal-close-btn" onClick={handleClose}>×</button>
                </div>

                <div className="modal-body">
                    <div className="search-section">
                        <div className="search-input-group">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Search for patents by keyword, company, or patent number..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyPress={handleKeyPress}
                            />
                            <select
                                value={searchType}
                                onChange={(e) => setSearchType(e.target.value)}
                                style={{
                                    padding: '10px',
                                    border: '2px solid #e2e8f0',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    cursor: 'pointer'
                                }}
                            >
                                <option value="ai">AI Search</option>
                                <option value="assignee">Company</option>
                                <option value="title">Title</option>
                                <option value="abstract">Abstract</option>
                            </select>
                            <button 
                                className="search-btn"
                                onClick={handleSearch}
                                disabled={searching}
                            >
                                {searching ? 'Searching...' : 'Search'}
                            </button>
                        </div>

                        {errorMessage && (
                            <div style={{
                                padding: '12px',
                                background: '#fee2e2',
                                border: '1px solid #fecaca',
                                borderRadius: '6px',
                                color: '#991b1b',
                                fontSize: '14px'
                            }}>
                                {errorMessage}
                            </div>
                        )}
                    </div>

                    {searchResults.length > 0 && (
                        <div className="search-results">
                            <div className="search-results-header">
                                Found {searchResults.length} patent{searchResults.length !== 1 ? 's' : ''}
                            </div>

                            {searchResults.map((patent) => (
                                <div key={patent.patent_number || patent.id} className="result-item">
                                    <div className="result-item-header">
                                        <div style={{ flex: 1 }}>
                                            <div className="result-patent-number">
                                                US{patent.patent_number || patent.id}
                                            </div>
                                            <div className="result-title">
                                                {patent.title || 'No title'}
                                            </div>
                                            <div className="result-assignee">
                                                {patent.assignees && patent.assignees.length > 0 
                                                    ? (Array.isArray(patent.assignees) ? patent.assignees[0] : patent.assignees)
                                                    : patent.assignee || 'Unassigned'}
                                                {patent.grant_date && ` • ${new Date(patent.grant_date).getFullYear()}`}
                                            </div>
                                        </div>

                                        {isAlreadyAdded(patent.patent_number || patent.id) ? (
                                            <div className="already-added-badge">
                                                ✓ Already Added
                                            </div>
                                        ) : (
                                            <button
                                                className="add-to-comparison-btn"
                                                onClick={() => handleAddToComparison(patent)}
                                            >
                                                Add to Comparison
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <CompanyDisambiguationModal
                show={showDisambiguation}
                onClose={() => setShowDisambiguation(false)}
                query={searchQuery}
                matches={disambiguationMatches}
                onSelect={handleDisambiguationSelect}
                loading={false}
            />
        </div>
    );
}



